import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const StyleClipAddBtn = styled.div`
  position: relative;

  .style-clip-add-btn {
    overflow: hidden;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: #000;

    svg path {
      fill: #fff;
    }
  }

  .tooltip-item {
    position: absolute;
    top: 2px;
    right: 46px;

    em {
      color: #ff6b33;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .style-clip-add-btn {
      width: ${mixin.pxToVw('36')};
      height: ${mixin.pxToVw('36')};
      border-radius: ${mixin.pxToVw('6')};

      svg {
        width: ${mixin.pxToVw('14')};
        height: ${mixin.pxToVw('14')};
      }
    }

    .tooltip-item {
      top: ${mixin.pxToVw('2')};
      right: ${mixin.pxToVw('46')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .style-clip-add-btn {
      width: 44px;
      height: 44px;
      border-radius: 7px;
    }

    .tooltip-item {
      top: 8px;
      right: 54px;
    }
  }
`;
